module.exports = __webpack_public_path__ + "static/media/orders.271b85e8.svg";